import React, { useState, useEffect, useMemo, useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Table from '@components/table';
import { GetJson } from '@awp/helpers/fetchReact';
import { REST_API, DASHBOARD_QUALITY_COLOURS } from '@awp/constants';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { Button, Row, Col, Card, Form, Alert } from 'react-bootstrap';
import { debounce } from '@awp/helpers/Utils';
import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import { isValueEmpty, getUtcToLocalByFormat, getLocalByFormat } from '@awp/helpers/utilsReact';
import { format as formatDate } from 'date-fns';
import { IconCaretDownFill, IconCaretRightFill } from '@awp/components/awpIcons';
import DetailIngestFailureTable from '@awp/components/AvalancheMonitor/GraphView/DetailIngestFailureTable';

const DetailQualityTable = ({ idx, requestDTO, convertPecentage }) => {
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const [sort, setSort] = useState([{ id: 'EventType', desc: false }]);
  /* useEffect(() => {
		const handleResize = debounce(() => {
			setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
		}, 100);

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		}
	}); */

  const getConvertPecentage = (row, idx) => {
    let invalidRed = isValueEmpty(row.CountFailed) ? 0 : row.CountFailed;
    let validGreen = isValueEmpty(row.CountIngested) ? 0 : row.CountIngested;
    let colors = [validGreen, invalidRed];
    return convertPecentage(colors, idx);
  };

  const cellComponentExp = ({ row }) => (
    // Use Cell to render an expander for each row.
    // We can use the getToggleRowExpandedProps prop-getter
    // to build the expander.
    <span {...row.getToggleRowExpandedProps()}>{row.isExpanded ? <IconCaretDownFill /> : <IconCaretRightFill />}</span>
  );
  const TableColumns = useMemo(
    () => [
      {
        // Make an expander cell
        Header: () => null, // No header
        id: 'expander', // It needs an ID
        Cell: cellComponentExp,
      },
      {
        Header: 'Event Type',
        accessor: 'EventTypeDisplayName',
        //className:"col-1",
        //sortType: sortByNumericThenAlpha,
      },
      {
        Header: '',
        accessor: 'CountFailed',
        className: 'col-1',
        //sortType: sortByNumericThenAlpha,
        Cell: ({ row, value }) => {
          if (!row.original) return '';
          return (
            <Row>
              <Col lg={5} md={5} style={{ paddingLeft: '0', paddingRight: '0', display: 'flex' }}>
                <button
                  type="button"
                  className="btn btn-sm text-white"
                  style={{ backgroundColor: `${DASHBOARD_QUALITY_COLOURS[0]}`, marginRight: '0.4rem', fontSize: '96%' }}
                >
                  {getConvertPecentage(row.original, 0)}
                </button>
                <button
                  type="button"
                  className="btn btn-sm text-white"
                  style={{
                    backgroundColor: `${DASHBOARD_QUALITY_COLOURS[1]}`,
                    marginRight: '0.4rem',
                    color: '#D2B208',
                    fontSize: '96%',
                  }}
                >
                  {getConvertPecentage(row.original, 1)}
                </button>
              </Col>
            </Row>
          );
        },
      },
    ],
    [isMedium],
  );
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Find current values of search and filter

  useEffect(() => {
    if (!requestDTO) return;
    let _grpDetails = _.groupBy(requestDTO, (ws) =>
      JSON.stringify({
        ProgramId: ws.ProgramId,
        AreaId: ws.AreaId,
        AreaLabel: ws.AreaLabel,
        EventType: ws.EventType,
        EventTypeDisplayName: ws.EventTypeDisplayName,
      }),
    );
    let wxs = []; //ws= area
    Object.keys(_grpDetails).map((index) => {
      let grpWx = _grpDetails[index];
      let newWx = JSON.parse(index);
      let validGreen = 0;
      let invalidRed = 0;
      newWx.QualityColors = [0, 0];
      let filterGrpWx = [];
      Object.keys(grpWx).map((gw) => {
        if (!isValueEmpty(grpWx[gw].AreaId)) filterGrpWx.push(grpWx[gw]);
      });
      if (filterGrpWx && filterGrpWx.length > 0) {
        let validWx = filterGrpWx;
        let failedIds = [];
        Object.keys(validWx).map((key) => {
          if (validWx[key] && validWx[key].Status === 'IngestFailed') {
            invalidRed++;
            failedIds.push(validWx[key].Id);
          } else if (validWx[key] && validWx[key].Status === 'Ingested') {
            validGreen++;
          }
        });
        newWx.QualityColors = [validGreen, invalidRed];
        newWx.CountFailed = invalidRed;
        newWx.CountIngested = validGreen;
        newWx.FailedIds = failedIds;
      }
      wxs.push(newWx);
    });
    setData(wxs); //children function of interest
  }, [requestDTO]);

  const getSensorObservationDTOList = (sensorPlacementId) => {
    if (isValueEmpty(requestDTO)) return null;
    if (isValueEmpty(sensorPlacementId)) return null;
    let _requestDTO = [...requestDTO];
    return _requestDTO.find((v) => v.SensorPlacementId === sensorPlacementId);
  };
  const renderRowSubComponent = useCallback(({ row }) => {
    if (!row || !row.original) return;
    if (!row.original.FailedIds || row.original.FailedIds.length === 0) return;
    let id = row.original.AreaId + (row.original.EventType + '').replace(' ', '');
    let failedList = row.original.FailedIds ? row.original.FailedIds : [];
    return (
      <Row>
        <Col>
          <DetailIngestFailureTable idx={`tbl_detail_ingest_failed_${id}`} ingestFailedList={failedList} />
        </Col>
      </Row>
    );
  }, []);

  return (
    <Table
      id={idx}
      columns={TableColumns}
      data={data}
      fetchData={() => {}}
      loading={loading}
      search={[]}
      filters={[]}
      dataTriggers={[]}
      sort={sort}
      setSort={setSort}
      renderRowSubComponent={renderRowSubComponent}
      //defaultDesc={true}
      //expendCellStyle={{ paddingTop: "0rem", paddingBottom: "0rem" }}
      defaultPageSize={5} //must be one of [5, 10, 25, 50, 100]
    />
  );
};
DetailQualityTable.propTypes = {
  idx: PropTypes.string,
  //requestDTO:PropTypes.object
};
export default DetailQualityTable;
